import { Component, HostBinding, Input, OnInit } from "@angular/core";
import "./veri-panel.component.scss";

@Component({
    selector: "veri-panel",
    template: require("./veri-panel.component.html")
})
export class VeriPanelComponent implements OnInit {

    @HostBinding("class.flat-transparent") @Input() flatTransparent: boolean;

    constructor() {}

    ngOnInit(): void {

    }
}
